import React from "react";
import LocalTag from "../shared/LocalTag";

const ChaptersRow = ({ index, summarySection }) => (
  <div className={`${index === 0 ? "first" : ""} row`}>
    <span className="title-4 left-aligned">{summarySection.title} </span>
    <div className="literary-devices local-tags-container">
      {summarySection.litTerms.map((litTerm) => (
        <LocalTag key={litTerm.id} litTerm={litTerm} />
      ))}
    </div>
  </div>
);

export default ChaptersRow;
